module.exports = __webpack_public_path__ + "static/media/est_0003_f.69ff8f74.jpg";